// import Vue from 'vue'
import order from '@/api/order'
import { DEVICE_TYPE } from '@/utils/device'
import { mapState } from 'vuex'

// const mixinsComputed = Vue.config.optionMergeStrategies.computed
// const mixinsMethods = Vue.config.optionMergeStrategies.methods

const mixin = {
  computed: {
    ...mapState({
      layoutMode: state => state.app.layout,
      navTheme: state => state.app.theme,
      primaryColor: state => state.app.color,
      colorWeak: state => state.app.weak,
      fixedHeader: state => state.app.fixedHeader,
      fixSiderbar: state => state.app.fixSiderbar,
      fixSidebar: state => state.app.fixSiderbar,
      contentWidth: state => state.app.contentWidth,
      autoHideHeader: state => state.app.autoHideHeader,
      sidebarOpened: state => state.app.sidebar,
      multiTab: state => state.app.multiTab,
    })
  },
  methods: {
    isTopMenu () {
      return this.layoutMode === 'topmenu'
    },
    isSideMenu () {
      return !this.isTopMenu()
    }
  }
}

const mixinDevice = {
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  methods: {
    isMobile () {
      return this.device === DEVICE_TYPE.MOBILE
    },
    isDesktop () {
      return this.device === DEVICE_TYPE.DESKTOP
    },
    isTablet () {
      return this.device === DEVICE_TYPE.TABLET
    }
  }
}

const mixinOrder = {
  data(){
    return {
      // 批量操作选中的key
      selectedRowKeys:[],
      // 批量操作选中的商品项
      selectedGoods:[],
      // 批量操作选中的机器人id
      selectedSubId:[]
    }
  },
  computed:{
    // 能否点击批量操作
    canClickMore(){
      return Array.from(new Set(this.selectedSubId)).length>1?false:true
    }
  },
  methods:{
    // 多选
    onSelectChange(selectedRowKeys,rows){
      this.selectedRowKeys = selectedRowKeys;
      this.selectedSubId = rows.map(item=>{
        return item.sub_id
      })
      this.selectedGoods = rows.map((item)=>{
        let orderType = ''
        if(!isNaN(item.tk_status)){
          orderType='tb'
        }else if(!isNaN(item.validCode)){
          orderType='jd'
        }else if(!isNaN(item.order_status)){
          orderType='pdd'
        }else if(!isNaN(item.orderSubStatus)){
          orderType='wph'
        }
        return {
          id:item.id,
          sub_id:item.sub_id,
          goods_status:item.tk_status||item.validCode||item.order_status||item.orderSubStatus,
          luckdrawTAG:item.luckdrawTAG,
          hasUserInfo:item.user_info?true:false,
          flstatus:item.flstatus,
          orderType
        }
      })
    },
    // 批量结算
    handleMoreJiesuan(){
      const reList = this.selectedGoods.map(item=>{
        const {goods_status,orderType,flstatus} = item
        if(orderType==='tb'){
          return (goods_status != 12 && goods_status != 14 && goods_status != 3) || flstatus != 0 ? false : item
        }else if(orderType==='jd'){
          return (goods_status != 16 && goods_status != 17) || flstatus != 0 ? false : item
        }else if(orderType==='pdd'){
          return (goods_status != 0 && goods_status != 1 && goods_status != 5) || flstatus != 0 ? false : item
        }else if(orderType==='wph'){
          return goods_status == 1 || goods_status == 2 || goods_status == 6 || flstatus != 0 ? false : item
        }else{
          return ''
        }
      })

      for(let i=0; i<reList.length; i++){
        setTimeout(() => {
          reList[i]&&this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: reList[i].sub_id,
            type: 'operationorder',
            data: {
              orderid: reList[i].id,
              type: '1',
              sourceby: this.sourceby
            }
          })
        }, i * 5000)
      }
      
      // reList.forEach(item=>{
      //   item&&this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
      //     robotid: item.sub_id,
      //     type: 'operationorder',
      //     data: {
      //       orderid: item.id,
      //       type: '1',
      //       sourceby: this.sourceby
      //     }
      //   })
      // })

      setTimeout(()=>{
        this.$message.success('发送指令成功')
      },2000)
    },
    // 批量解冻
    handleMoreJiedong(){
      const reList = this.selectedGoods.map(item=>{
        return item.luckdrawTAG != 1 ? false : item
      })

      for(let i=0; i<reList.length; i++){
        setTimeout(() => {
          reList[i]&&this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: reList[i].sub_id,
            type: 'operationorder',
            data: {
              orderid: reList[i].id,
              type: '2',
              sourceby: this.sourceby
            }
          })
        }, i * 5000)
      }

      // reList.forEach(item=>{
      //   item&&this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
      //     robotid: item.sub_id,
      //     type: 'operationorder',
      //     data: {
      //       orderid: item.id,
      //       type: '2',
      //       sourceby: this.sourceby
      //     }
      //   })
      // })
      
      setTimeout(()=>{
        this.$message.success('发送指令成功')
      },2000)
    },
    // 批量解绑
    handleMoreJiebang(){
      for(let i=0; i<this.selectedGoods.length; i++){
        setTimeout(() => {
          // console.log(12345679)
          this.selectedGoods[i].hasUserInfo&&this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: this.selectedGoods[i].sub_id,
            type: 'operationorder',
            data: {
              orderid: this.selectedGoods[i].id,
              type: '5',
              sourceby: this.sourceby
            }
          })
        }, i * 5000)
      }

      // this.selectedGoods.forEach(item=>{
      //   item.hasUserInfo&&this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
      //     robotid: item.sub_id,
      //     type: 'operationorder',
      //     data: {
      //       orderid: item.id,
      //       type: '5',
      //       sourceby: this.sourceby
      //     }
      //   })
      // })

      setTimeout(()=>{
        this.$message.success('发送指令成功')
      },2000)
    },
    // 批量退款
    handleMoreTuikuan(){
      const reList = this.selectedGoods.map(item=>{
        const {goods_status,orderType} = item
        if(orderType==='tb'){
          return goods_status == 4 || goods_status == 13?false:item
        }else if(orderType==='jd'){
          return goods_status != '16' && goods_status != '17' ? false:item
        }else if(orderType==='pdd'){
          return goods_status != 0 &&
                goods_status != 1 &&
                goods_status != 2 &&
                goods_status != 3 &&
                goods_status != 5 ? false:item
        }else if(item.orderType==='wph'){
          return goods_status != '3' && goods_status != '4' && goods_status != '5' ? false : item
        }else{
          return ''
        }
      })

      for(let i=0; i<this.selectedGoods.length; i++){
        setTimeout(() => {          
          this.selectedGoods[i]&&this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: this.selectedGoods[i].sub_id,
            type: 'operationorder',
            data: {
              orderid: this.selectedGoods[i].id,
              type: '3',
              sourceby: this.sourceby
            }
          })
        }, i * 5000)
      }
      
      // reList.forEach(item=>{
      //   item&&this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
      //     robotid: item.sub_id,
      //     type: 'operationorder',
      //     data: {
      //       orderid: item.id,
      //       type: '3',
      //       sourceby: this.sourceby
      //     }
      //   })
      // })

      setTimeout(()=>{
        this.$message.success('发送指令成功')
      },2000)
    }
  }
}
export { mixin, mixinDevice,mixinOrder }
